import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ConfirmationModal({
                               show,
                               onHide,
                               action,
                               ticket,
                               handleConfirmAction
                           }) {
    const { t } = useTranslation();
    const actionText = action === 'CLOSED' ? 'clôturer' : 'archiver';

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{action === 'CLOSED' ? "Confirmation de clôture" : "Confirmation d'archivage"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Souhaitez-vous {actionText} la demande n°{ticket.id} "{ticket.subject}" ?</p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button variant="secondary" onClick={onHide}>{t('CANCEL')}</Button>
                <Button variant="primary" onClick={handleConfirmAction}>{t('CONFIRM')}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationModal;